import * as React from 'react';
import { getCategorySpecificationListItems, ProductDetailSpecificationView } from '@grandvisionhq/fun-products';
import { useIntl } from '@grandvisionhq/state';
import { getActiveVariant } from '../../../helpers.js';
import { useProductDetailContext } from '../../Context/ProductDetailContext.js';
import { getConfigurationSpecificationItems } from './utils/get-configuration-specification-items.js';

const ProductDetailSpecificationContainer = ({ fallbackConfiguration  })=>{
    const { getLabel , locale  } = useIntl();
    const { product , activeSku , specificationConfiguration  } = useProductDetailContext();
    const activeVariant = getActiveVariant(product, activeSku);
    const configuration = specificationConfiguration || fallbackConfiguration;
    if (!configuration || !activeVariant) {
        return null;
    }
    var _commercialCategories;
    const items = [
        ...getConfigurationSpecificationItems(configuration, activeVariant, getLabel, locale),
        ...getCategorySpecificationListItems((_commercialCategories = product.commercialCategories) !== null && _commercialCategories !== void 0 ? _commercialCategories : []), 
    ];
    if (!items.length) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ProductDetailSpecificationView, {
        className: "product-detail__specification",
        items: items
    });
};

export { ProductDetailSpecificationContainer };
//# sourceMappingURL=ProductDetailSpecificationContainer.js.map
